/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerformata6portrait3Inputs */

const en_flyerformata6portrait3 = /** @type {(inputs: Flyerformata6portrait3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A6 table card`)
};

const de_flyerformata6portrait3 = /** @type {(inputs: Flyerformata6portrait3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A6 Tischkarte`)
};

/**
* | output |
* | --- |
* | "A6 table card" |
*
* @param {Flyerformata6portrait3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerformata6portrait3 = /** @type {((inputs?: Flyerformata6portrait3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerformata6portrait3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerformata6portrait3(inputs)
	return de_flyerformata6portrait3(inputs)
});
export { flyerformata6portrait3 as "flyerFormatA6Portrait" }